/**
 * The gate an unchecked panel id passes through. `PANEL_IDS` and `PanelId` sit
 * with the shell's other contracts in `@/types/panels`; the lookup and the
 * narrowing are runtime, so they live here.
 */
import type { PanelId } from '@/types/panels';
import { PANEL_IDS } from '@/types/panels';

import { panelSwitches } from './panelSwitches';

const KNOWN: ReadonlySet<unknown> = new Set(PANEL_IDS);

/**
 * The only way a value the compiler cannot vouch for — a URL's `panels=`, a
 * restored session, an id the model chose — becomes a `PanelId`.
 *
 * Takes `unknown` so a caller reading parsed JSON does not have to prove the
 * value is a string first: anything that is not one simply is not a panel id.
 * Neither is the id of a panel that the deployment switches off.
 */
export function isPanelId(value: unknown): value is PanelId {
    return KNOWN.has(value) && !panelSwitches.isOff(value);
}
